import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, firstValueFrom, lastValueFrom, skip, takeUntil } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { KeycloakUser } from 'src/app/shared/models/database-models/KeycloakUser.model';
import {
  ExtendedKeycloakUser,
  MyPurchaseForm,
  StoreDropdowns,
} from 'src/app/shared/models/app-models';
import { Location } from '@angular/common';
import { KeycloakADUser } from 'src/app/shared/models/database-models/KeycloakADUser';
import { PageEvent } from '@angular/material/paginator';
@Component({
  selector: 'app-workflow-history',
  templateUrl: './workflow-history.component.html',
  styleUrls: ['./workflow-history.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class WorkflowHistoryPageComponent implements AfterViewInit, OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  currentRoute: string[] = ['My Worklist'];
  breadCrumbFlow:string[]=['Purchase Modes'];
  currentPageString: string = 'Workflow History';
  activePage:string='Workflow History';
  columnsToDisplay = ['action', 'workflow', 'personnel', 'appointment', 'date'];
  columnsToDisplayWithExpand = ['expand', ...this.columnsToDisplay];
  dataSource = new MatTableDataSource<WorkflowHistory>(ELEMENT_DATA);
  expandedElement: WorkflowHistory | null = null;
  mpDocumber: string = '';
  form!: MyPurchaseForm;
  destroy$: Subject<boolean> = new Subject<boolean>();
  KCUserList: KeycloakADUser[] = [];
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage: number = 0;
  totalCount: number = 0;
  pageSize: number = 5;
  isLoadingData: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private backEndService: BackendApiService,
    private store: Store<{ form: MyPurchaseForm; dp: StoreDropdowns }>,
    private location: Location
  ) {
    const previousPageName = sessionStorage.getItem('fromPage');
    if (previousPageName) {
      this.breadCrumbFlow = [previousPageName];
    } 
    if (this.route.snapshot.params['id']) {
      //from ao
      this.currentRoute.push(this.route.snapshot.params['id'] as string);
      this.breadCrumbFlow.push(this.route.snapshot.params['id'] as string);
      const mpDocumber = this.route.snapshot.params['id'].split(';')[0] as string;
      this.mpDocumber = mpDocumber;
    }

    this.store
      .select('dp')
      .pipe(takeUntil(this.destroy$))
      .subscribe((dp: StoreDropdowns) => {
        this.KCUserList = dp.UserList as ExtendedKeycloakUser[];
      });
  }
  async ngOnInit(): Promise<void> {
    try {
      this.isLoadingData = true
      //await new Promise(res => setTimeout(res, 5000));
      if (this.mpDocumber.length === 0) {
        this.store
          .select('form')
          .pipe(takeUntil(this.destroy$))
          .subscribe((data) => {
            this.form = data;
          });
        this.mpDocumber = this.form.documentNo as string;
      }
      if (this.KCUserList.length == 0) {
        this.KCUserList = (
          await firstValueFrom(this.store.select('dp').pipe(skip(1)))
        ).UserList as ExtendedKeycloakUser[];
      }
      this.loadDataBasedOnPageAndLimit()
    } catch (e) { }
    finally {
      this.isLoadingData = false
    }
  }
      
  async loadDataBasedOnPageAndLimit() {
    this.isLoadingData = true;
    let data: any = await lastValueFrom(
      this.backEndService.getCompleteWorkflowHistory(
        this.mpDocumber,
        this.pageSize,
        (this.currentPage + 1)
      )
    );

    this.dataSource.data = data.workFlowHistory;
    this.totalCount = data.totalCount;

    setTimeout(() => {
      this.isLoadingData = false;
      // if (data.totalCount == 0) this.getEmptyMessage(this.index);
    }, 100);
  }
  //not in use (using CoveringName, PersonnelName)
  getFullNameOfUser(userName: string) {
    if (userName && userName.length > 0) {
      let userResult = this.KCUserList.find((user) => user.username == userName)
      if (userResult) return userResult.last_name
      return userName
    }
    else return userName
  }
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
  }

  returnToPreviousPage = (args: any): void => {
    this.location.back();
  };
  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  async onPageChange(event: PageEvent) {
    // console.log('onPageChange', event);
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    await this.loadDataBasedOnPageAndLimit();
  }
}

const ELEMENT_DATA: WorkflowHistory[] = [
  {
    Action: '-',
    Workflow: '-',
    Personnel: '-',
    Appointment: '-',
    Date: null,
    Comment: '-',
    IsCovering: null,
    Covering: null
  },
];

interface WorkflowHistory {
  Action: string;
  Workflow: string;
  Personnel: string;
  Appointment: string;
  Date: Date | null;
  Comment: string;
  IsCovering: boolean | null;
  Covering: string | null;
}

export interface WorkflowRecord {
  workFlowHistory:WorkflowHistory[],
  totalCount: number
}